module.exports = __webpack_public_path__ + "img/clap.f37f5823.png";